/*
 * @Description: 任务记录中通用操作
 * @LastEditors: Please set LastEditors
 * @Date: 2020-12-02 10:26:49
 */
import { mapState } from 'vuex';
import personalBiDownload from './service/personalBiDownload.js';
import { projectCsoAuditShow } from '@/api/ajax';

export default {
  data() {
    return {
      // 如果甲乙都确认了则可使用个人BI导出功能 industryConfirm:1为甲方确认 csoStatus:1为乙方确认
      exportPersonalBiDisabled:
        localStorage.getItem('exportPersonalBiDisabled') === 'false'
          ? false
          : true,
      showReviewer: false
    };
  },
  computed: {
    ...mapState({
      projectInfo: state => state.homeProject
    })
  },
  methods: {
    // 个人报表全部导出，需要searchQuery参数
    personalBiDownload(type = 'batch') {
      personalBiDownload.call(this, type);
    },
    // 处理服务商审核人字段
    dealReviewer(row) {
      return row.csoAuditUser || '-';
    }
  },
  async created() {
    const { id, projectType } = this.projectInfo;
    if ([4, 5, 11, 12, 13, 14, 15, 17, 18, 19, 20].includes(+projectType)) {
      const {
        data: {
          data: { isShow }
        }
      } = await projectCsoAuditShow({
        projectId: id
      });
      this.showReviewer = isShow == 1;
    }
  }
};
